import axios from './axios.service'

const method = 'newsletters'

class NewsletterService {
  async index(queryData) {
    try {
      const response = await axios.get(`/${method}`, {
        params: { ...queryData }
      })
      return response.data
    } catch (error) {
      return error
    }
  }

  async show(id) {
    try {
      const response = await axios({
        method: 'get',
        url: `/${method}/${id}`
      })
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async delete(rowClicked) {
    try {
      const response = await axios.delete(`/${method}/${rowClicked.id}`)
      return response
    } catch (error) {
      return error
    }
  }

  async forceDelete(id, data) {
    try {
      const response = await axios.delete(`${method}/${id}/forcedelete`, {
        params: { ...data }
      })
      return response
    } catch (error) {
      return error
    }
  }

  async exportXls() {
    try {
      const response = await axios.get(`export/${method}`, {
        responseType: 'blob'
      })
      return response
    } catch (error) {
      return error
    }
  }
}

export default new NewsletterService()
